var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 49,
    viewBox: "0 0 40 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9924 49C8.97774 49 0 39.8844 0 28.6665C0 23.2493 2.12753 18.1391 5.97513 14.2872L7.36326 12.8907L13.097 18.7069C12.7198 15.9906 12.8706 13.1823 13.61 10.4354L14.0023 9.2844C14.3946 8.08741 14.8925 6.95177 15.481 5.84685C15.8733 5.11024 16.1901 4.64986 16.507 4.17413C17.2161 3.16129 17.8499 2.31727 18.6043 1.54997L19.9924 0L21.5013 1.41186L35.5187 15.6684L35.4583 15.7451C38.4006 19.3821 40 23.8938 40 28.6358C40 39.8538 31.0223 48.9693 20.0076 48.9693",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarm);
export default __webpack_public_path__ + "static/media/warm.0cea79998b890e8f0cdf6b5b6679b4c4.svg";
export { ForwardRef as ReactComponent };